import {START_EXPERIMENT} from '../actions'

const initialState = {
    label: null,
    ref: null,
}

const experiment = (state = initialState, action) => {
    switch (action.type) {
        case START_EXPERIMENT:
            return {
                ...state,
                label: action.payload.label,
                ref: action.payload.ref,
                id: action.payload.id
            }
        default:
            return state
    }
}

export default experiment



// WEBPACK FOOTER //
// ./src/reducers/experiments.js